import { Box, Button, makeStyles } from '@material-ui/core';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';
import {
  editBgColor,
  editBgImage,
  editCurrentIndex,
  editDeeplink
} from 'src/store/modules/imageUpload';
import { editText } from 'src/store/modules/editText';
import { RootState, useSelector } from 'src/store';
import Plus from 'src/components/Icon/Plus';
import Minus from 'src/components/Icon/Minus';
import { editBtnText } from 'src/store/modules/buttons';
import { TEMPLATES_EDITOR_REGARCY } from 'src/constants/templates';
import { editTracking } from 'src/store/modules/trackings';

const useStyles = makeStyles(() => ({
  wrapper: {
    padding: '1.5rem 1rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    backgroundColor: '#F5F5F5'
  },
  editor: {
    // margin: 'auto',
    display: 'flex',
    justifyContent: 'space-between'
  },
  title: {
    color: '#000',
    textAlign: 'center',
    fontFamily: 'Archivo',
    fontSize: '0.875rem',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: 'normal',
    letterSpacing: '0.0175rem'
  },
  scrollNumber: {
    margin: 'auto',
    overflowX: 'auto',
    display: 'flex',
    gap: '0.5rem'
  },

  numberBox: {
    maxWidth: '2rem',
    minWidth: '2rem',
    maxHeight: '2rem',
    minHeight: '2rem',

    color: '#000',
    fontFamily: 'Roboto',
    fontSize: '0.75rem',
    fontWeight: 400,

    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    backgroundColor: '#E0E0E0'
  },

  addSubtract: {
    width: '100%',
    height: '2.5rem',
    padding: '0.5rem',

    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    border: '1px solid #BDBDBD'
  },
  btnMinusPlus: {
    maxWidth: '1.5rem',
    minWidth: '1.5rem',
    maxHeight: '1.5rem',
    minHeight: '1.5rem',
    padding: 0,
    display: 'flex'
  },
  slideRight: {
    color: '#828282',
    textAlign: 'center',
    fontFamily: 'Roboto',
    fontSize: '0.75rem',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: 'normal'
  }
}));

const EditMulti = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const location = useLocation();
  const templateTitle = location?.pathname
    ?.split('/')?.[2]
    .toUpperCase()
    .split('-')
    .join(' ');
  const editDatas = TEMPLATES_EDITOR_REGARCY?.[templateTitle];
  const currentIndex = useSelector(
    (state: RootState) => state.imageUpload.currentIndex
  );
  const bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  const bgColor = useSelector((state: RootState) => state.imageUpload.bgColor);
  const deeplink = useSelector(
    (state: RootState) => state.imageUpload.deeplink
  );
  const text = useSelector((state: RootState) => state.editText.text);
  const btnText = useSelector((state: RootState) => state.buttons.btnText);
  const tracking = useSelector((state: RootState) => state.trackings.tracking);

  const datas =
    bgImage?.multi_background?.length ||
    bgImage?.multi_image?.length ||
    text?.multi_text?.length;

  const datasJSON = (
    datas: any,
    data: any,
    tf: boolean,
    tracking = false,
    option = false
  ) => {
    let json = {};
    for (let i = 0; i < datas?.length; i++) {
      const type = datas?.[i];

      const newJSON = data?.[type]?.slice();
      if (newJSON) {
        if (tf) {
          let str = data?.[type]?.[data?.[type]?.length - 1];
          if (tracking && !Array.isArray(data?.[type]?.[0])) {
            str = `${data?.[type]?.[0].replace(/\d+$/, '')}${data?.[type]
              ?.length + 1}`;
          } else if (tracking && Array.isArray(data?.[type]?.[0])) {
            str = str.map((_, idx) =>
              option
                ? 'log_name'
                : `option ${data?.[type]?.length + 1}-${idx + 1}`
            );
          }
          newJSON.push(str);
        } else newJSON.pop();
        const newJSONs = {};
        if (Array.isArray(newJSON?.[0]) || typeof newJSON?.[0] === 'string') {
          //     newJSONs = JSON.parse(
          //       `{"${type}": [${newJSON?.map((jsonData: any, idx: number) => {
          //         return typeof jsonData === 'object'
          //           ? `[${jsonData?.map((data: any) => {
          //               return `"${data}"`;
          //             })}]`
          //           : `"${jsonData}"`;
          //       })}]}`
          //     );
          //   } else {
          //     const b = JSON.stringify(newJSON);
          //     newJSONs = JSON.parse(`{"${type}": ${b}}`);
          //   }
          //   json = { ...json, ...newJSONs };
          //   console.log(json);
          // }
          newJSONs[type] = newJSON.map((jsonData: any) =>
            typeof jsonData === 'object'
              ? jsonData.map((data: any) => data)
              : jsonData
          );
        } else {
          newJSONs[type] = newJSON;
        }
        json = { ...json, ...newJSONs };
      }
    }
    return json;
  };

  const handleDatas = (tf: boolean) => {
    dispatch(editCurrentIndex(0));

    const newBackgroundJSON = datasJSON(
      editDatas?.text?.multiBgType,
      bgImage,
      tf
    );
    const newImageJSON = datasJSON(
      editDatas?.text?.multiImageType,
      bgImage,
      tf
    );
    dispatch(
      editBgImage({
        ...bgImage,
        ...newBackgroundJSON,
        ...newImageJSON
      })
    );
    const newBgColorJSON = datasJSON(
      editDatas?.text?.multiBgColorType,
      bgColor,
      tf
    );
    dispatch(
      editBgColor({
        ...bgColor,
        ...newBgColorJSON
      })
    );

    const newDeeplinkJSON = datasJSON(
      editDatas?.text?.multiDeeplinkType,
      deeplink,
      tf
    );
    dispatch(editDeeplink({ ...deeplink, ...newDeeplinkJSON }));

    const newTextJSON = datasJSON(editDatas?.text?.multiTextType, text, tf);
    const newCountdownJSON = datasJSON(
      editDatas?.text?.multiCountdownType,
      text,
      tf
    );
    dispatch(editText({ ...text, ...newTextJSON, ...newCountdownJSON }));

    const newButtonJSON = datasJSON(
      editDatas?.button?.multiBtnType,
      btnText,
      tf
    );
    dispatch(editBtnText({ ...btnText, ...newButtonJSON }));

    const newTrackingJSON = datasJSON(
      editDatas?.tracking?.trackingType,
      tracking,
      tf,
      true
    );
    dispatch(editTracking({ ...tracking, ...newTrackingJSON }));
  };

  return (
    <Box className={classes.wrapper}>
      <Box className={classes.title}>
        {editDatas?.button?.multiBtnType?.[0]?.indexOf('survey') === -1
          ? 'SLIDE'
          : 'QUESTION'}{' '}
        {currentIndex + 1}
      </Box>
      <Box className={classes.editor}>
        <Box className={classes.scrollNumber}>
          {[
            ...Array(
              bgImage?.multi_background?.length ||
                bgImage?.multi_image?.length ||
                text?.multi_text?.length
            )
          ]?.map((_: any, idx: number) => (
            <div
              key={idx}
              className={classes.numberBox}
              style={{
                color: currentIndex === idx ? '#000' : '#828282',
                border:
                  currentIndex === idx
                    ? '1.4px solid #000'
                    : '1px solid #828282'
              }}
              onClick={() => {
                dispatch(editCurrentIndex(idx));
              }}
            >
              {idx + 1}
            </div>
          ))}
        </Box>
      </Box>
      <Box className={classes.addSubtract}>
        {/* <Box style={{ display: 'flex', gap: '1rem' }}> */}
        <Box style={{ display: 'flex', gap: '1rem' }}>
          <Button
            className={classes.btnMinusPlus}
            disabled={
              datas === TEMPLATES_EDITOR_REGARCY?.[templateTitle]?.multi?.[0]
            }
            onClick={() => handleDatas(false)}
          >
            <Minus
              stroke={
                datas === TEMPLATES_EDITOR_REGARCY?.[templateTitle]?.multi?.[0]
                  ? '#BDBDBD'
                  : '#000'
              }
            />
          </Button>
          <Button
            className={classes.btnMinusPlus}
            disabled={
              datas === TEMPLATES_EDITOR_REGARCY?.[templateTitle]?.multi?.[1]
            }
            onClick={() => handleDatas(true)}
          >
            <Plus
              stroke={
                datas === TEMPLATES_EDITOR_REGARCY?.[templateTitle]?.multi?.[1]
                  ? '#BDBDBD'
                  : '#000'
              }
            />
          </Button>
        </Box>
        {/* </Box> */}
        <span className={classes.slideRight}>
          * Create up to {TEMPLATES_EDITOR_REGARCY?.[templateTitle]?.multi?.[1]}{' '}
          slides
        </span>
      </Box>
    </Box>
  );
};

export default EditMulti;
